/**
 * ConsentManager.Toggle
 *
 * @author Felix Kiesewetter <info@felixkiesewetter.de>
 * @lastModified 2024-12-18 TypeScript.
 * @package felixkiesewetter-js/consentmanager
 * @since 5.1.0
 */
class Toggle
{

    /**
     * Toggle constructor
     *
     * @param {HTMLInputElement} checkbox
     */
    constructor(checkbox :HTMLInputElement)
    {
        const toggleBox :HTMLSpanElement = document.createElement('span');
        toggleBox.classList.add('tag__toggle');
        if (checkbox.checked) {
            toggleBox.classList.add('-enabled');
        }
        if (checkbox.getAttribute('readonly')) {
            toggleBox.classList.add('-readonly');
        }
        else {
            checkbox.parentNode.addEventListener('click', (e) :boolean => {
                if ('A' === e.target.tagName) {
                    return true;
                }
                e.preventDefault();
                toggleBox.classList.toggle('-enabled');
                checkbox.checked = toggleBox.classList.contains('-enabled');
                checkbox.dispatchEvent(new Event('change'));
                toggleBox.parentNode.classList.remove('-highlighted');
                return false;
            })
        }
        checkbox.style.display = 'none';
        window.addEventListener('consentSettingsUpdated', () :void => {
            toggleBox.classList.toggle('-enabled', checkbox.checked);
        })
        checkbox.parentNode.insertBefore(toggleBox, checkbox);
    }

}

export default Toggle;
